import { render, staticRenderFns } from "./beyond-the-nets.vue?vue&type=template&id=53c5e622&scoped=true&"
var script = {}
import style0 from "./beyond-the-nets.vue?vue&type=style&index=0&id=53c5e622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5e622",
  null
  
)

export default component.exports